import { Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { SearchService } from '../../../shared/services/search.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { masterData } from './image-price';
import { Results, Sizes, User } from '../../../shared/classes/app.models';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ModalService } from '../../../shared/services/modal.service';
import { CartService } from '../../../shared/services/cart.service';
import { DataService } from 'src/app/shared/services/data.service';
import { StoreService } from 'src/app/core/store/store.service';
import { BudgetService } from 'src/app/shared/services/budget.service';
import { AiEditSource } from 'src/app/shared/components/ai-edit-modal/ai-edit-modal.component';
declare var window: any;

@Component({
    selector: 'indiapicture-media-detail',
    templateUrl: './media-detail.component.html',
    styleUrls: ['./media-detail.component.scss']
})

export class MediaDetailComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();

    loaded = false;
    category: string;
    id: any;
    collection: any;
    private sub: Subscription;
    btn: number;
    disableBtn: boolean = false;
    exist: boolean = true;
    private imagePrice: any;
    images: Results;
    private imagesPriceExist: boolean;
    private params:any;
    cartProduct: any;
    media_usage: any;
    type = 'images';
    code: string;
    public editorial: Array<string> = ['210', '23', '208', '13', '132', '162', '168', '169', '170'];
    public usage = false;
    public usageType:any;
    public partner = ['93', '210', '179', '130', '211', '172', '160', '124', '161'];
    private wish: {} & Results;
    collectionSize: any;
    // private categories: any;
    relatedProducts: any[];
    previewArr = [];
    currentUser: any;
    currentPlan: string;
    selectedSize:any;
    url = 'https://' + window.location.host;
    selectedSizePrice: any = [];
    usageSelected = '';
    categories: any;
    license: any;
    isAnySizeDownoaded: any = 0;
    total_images: number = 0;


    constructor(
        public apiService: ApiService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public authService: AuthenticationService,
        public toastService: ToastrService, public searchService: SearchService,
        public modalService: ModalService,
        public cartService: CartService,
        public el: ElementRef,
        public dataService: DataService,
        public storageService: StoreService,
        public BUdgetService: BudgetService
    ) {
        this.authService.currentUser.subscribe(x => this.currentUser = x);
        if(this.currentUser && this.currentUser?.license_type == 'standard_subscription' || 
            this.currentUser?.license_type == 'standard_monthly' ||
            this.currentUser?.license_type == 'standard_yearly' 
        ){
            this.currentPlan = 'Digital Media';
        } else {
            this.currentPlan = 'All Media';
        }
    }

    ngOnInit(): void {
        if(this.currentUser && this.currentUser.isExclusive == true) {
            return;
        }
        this.searchService = SearchService.getInstance();
        const param = this.router.parseUrl(this.router.url);
        this.btn = 0;
        if (this.currentUser && this.currentUser.user_type == 'BUDGET') {
            this.getBudgetCategories();
        }
        this.sub = this.activatedRoute.params.subscribe(params => {
            this.id = params.id;
            this.collection = params.collection;
            this.type = params.type.toLowerCase();
            // this.getCollections();

            this.type == 'images' ? this.getImageById() : this.getVideoById();

        });
        this.category = param.queryParams.category;

        // if (this.category == 'editorial-videos') {
        //     this.usageType = data.usage[0].creative;
        // } else if (this.category == 'editorial') {
        //     this.usageType = data.usage[0].creative;
        // } else if (this.category == 'creative-videos') {
        //
        // } else {
        //     this.usageType = data.usage[0].creative;
        // }
        this.searchService.setCategory(this.category);

        this.getCurrentUser();
        this.getPackageHistory();
    }

    public getPackageHistory() {
        if (!this.currentUser?.customers_id) {
            return;
        }
        if(this.currentUser && this.currentUser?.user_type == 'BUDGET') {

        }else{
            this.apiService.getPackageHistory(this.currentUser.customers_id).subscribe(data => {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                this.total_images = (data || [])
                    .filter(order => order?.validity && new Date(order.validity) > today)
                    .reduce((sum, order) => sum + (Number(order.total_images) || 0), 0);
            });
        }
       
    }

    getCurrentUser() {
        this.dataService.currentData$
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
            if (data) {
                this.currentUser = data;
                if (this.currentUser && this.currentUser?.license_type == 'standard_subscription') {
                    this.currentPlan = 'Digital Media';
                } else {
                    this.currentPlan = 'All Media';
                }
            } else {
                const user = this.storageService.getItem('currentUser');
                // console.log('StorageService ==>', user);
                if (user) {
                    this.currentUser = user;
                    if (this.currentUser && this.currentUser?.license_type == 'standard_subscription') {
                        this.currentPlan = 'Digital Media';
                    } else {
                        this.currentPlan = 'All Media';
                    }
                }
            }

        });
    }

    getBudgetCategories() {
        if (this.BUdgetService.Data.categories && this.BUdgetService.Data.categories.length) {
            this.categories = this.BUdgetService.Data.categories;
            return;
        }
        this.BUdgetService.getBudgetCategories().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
            this.categories = data || [];
            this.BUdgetService.Data.categories = this.categories;
        });
    }

    getCollections() {
        if(this.currentUser && this.currentUser.user_type == 'BUDGET') {

        }else{
            this.apiService.getCollectionById(this.collection).subscribe(result => {
                this.collectionSize = result['data'];
                // console.log('collection-id ', this.collectionSize)
                this.changeSize(this.images?.sizes[this.images.sizes.length - 1]);
            });
        }
            
    }

    public getData() {
        // this.imagePrice = masterData.imagePrice;
        if(this.currentUser && this.currentUser.user_type == 'BUDGET') {

        }else{
            this.apiService.getImagePrice(this.images?.filename).subscribe(result => {
                this.imagePrice = result['data'];
                this.changeSize(this.images?.sizes[this.images.sizes.length - 1]);
            });
        }
            
    }

    public getImageById() {

        if(this.currentUser && this.currentUser.user_type == 'BUDGET') {
            this.BUdgetService.pageView(this.router.url, 0).pipe(takeUntil(this.destroy$)).subscribe();
            this.BUdgetService.getImageById(this.id, this.collection, 'image').pipe(takeUntil(this.destroy$)).subscribe(data => {
                if (data.error && data.error != '') {
                    this.exist = false;
                }

                this.images = data;
                if(!this.currentUser){
                    this.images.sizes = this.images.sizes.filter(item => item.name == 'Extra Large');
                }
                this.images.tags = this.images?.tags.filter(item => item);

                if (this.images?.sizes) {
                    this.selectedSize = this.images?.sizes[(this.images?.sizes.length - 1)];
                } else {
                    this.selectedSize = null;
                }

                /*
                 * The detail accordion renders on `loaded` (see the template's
                 * `*ngIf="!loaded else infoBlock"`), and everything it shows --
                 * filename, description, tags, sizes, restrictions -- is already
                 * present in `images` by this point.
                 *
                 * It used to be set on the last line of this callback instead,
                 * after getSubscriptionDetail(), getRelatedProducts() and the usage
                 * lookups had all run. Any one of those throwing left `loaded`
                 * false for good, so the page sat on its loading skeleton and the
                 * details never appeared -- and those later calls are exactly the
                 * ones that differ between a signed-in and a signed-out visitor,
                 * which is why this showed up in one state and not the other.
                 *
                 * Setting it here means the details are governed by whether the
                 * image loaded, not by whether every follow-up call succeeded.
                 */
                this.loaded = true;

                if (this.partner.filter(item => item == this.collection).length > 0) {
                    this.code = this.images.filename.substr(0, 4);
                } else {
                    this.code = this.images.author;
                }

                const vect = this.images?.sizes.filter(item => item.name == 'Vector');

                if (vect.length > 0 && this.images?.sizes?.length >= 2) {
                    this.images?.sizes?.splice(0, this.images?.sizes?.length - 2);
                }

                if (this.editorial.indexOf(this.collection) > -1) {
                    this.usage = true;
                    this.category = 'editorial';
                } else if (this.collection == '179') {
                    this.usage = data.iseditorial;
                    this.category = 'creative';
                }

                if (this.usage) {
                    if (this.type == 'images') {
                        this.usageType = masterData.usage[0]['editorial'];
                    } else {
                        this.usageType = masterData.usage[0]['editorial-videos'];
                    }
                } else {
                    if (this.type == 'images') {
                        this.usageType = masterData.usage[0]['creative'];
                    } else {
                        this.usageType = masterData.usage[0]['creative-videos'];
                    }
                }
                this.usageSelected = this.usageType[0].id;

                this.cartProduct = Object.assign({
                    id: data.id,
                    filename: data.filename,
                    thumbnail: data.thumbnail,
                    license: data.license,
                    collection: data.collection,
                    size: data?.sizes ? data?.sizes[data.sizes.length - 1]?.name : null,
                    price: 21000,
                    type: this.type == 'images' ? 'Image' : 'Video',
                    caption: data.caption,
                    category: this.category,
                    searchText: this.searchService.search.getValue(),
                    usage: this.usageSelected
                });
                if (this.collection == '219') {
                    this.getCollections();
                    this.getData();
                } else {
                    this.getCollections();
                }

                this.getSubscriptionDetail();
                if (this.images.collection == '179') {
                    this.setRelated(this.images.similar || []);
                    this.topUpSimilar();
                } else {
                    this.getRelatedProducts();
                }

                this.wish = Object.assign({}, this.images);
                this.loaded = true;
            });
        }else{
        this.apiService.getImageById(this.id, this.collection, this.searchService.search.getValue()).subscribe(data => {
            if (data.error && data.error != '') {
                this.exist = false;
            }

            // console.log('image detail  => ', data);
        
            // Signed-out visitors used to see 'Extra Large' only. The guest buy
            // panel offers every size, so the list is no longer trimmed here.
            this.images = data;
                this.images.tags = this.images?.tags.filter(item => item);

                if (this.images?.sizes) {
                    this.selectedSize = this.images?.sizes[(this.images?.sizes.length - 1)];
                } else {
                    this.selectedSize = null;
                }

                /*
                 * The detail accordion renders on `loaded` (see the template's
                 * `*ngIf="!loaded else infoBlock"`), and everything it shows --
                 * filename, description, tags, sizes, restrictions -- is already
                 * present in `images` by this point.
                 *
                 * It used to be set on the last line of this callback instead,
                 * after getSubscriptionDetail(), getRelatedProducts() and the usage
                 * lookups had all run. Any one of those throwing left `loaded`
                 * false for good, so the page sat on its loading skeleton and the
                 * details never appeared -- and those later calls are exactly the
                 * ones that differ between a signed-in and a signed-out visitor,
                 * which is why this showed up in one state and not the other.
                 *
                 * Setting it here means the details are governed by whether the
                 * image loaded, not by whether every follow-up call succeeded.
                 */
                this.loaded = true;


                if (this.partner.filter(item => item == this.collection).length > 0) {
                    this.code = this.images.filename.substr(0, 4);
                } else {
                    this.code = this.images.author;
                }

                const vect = this.images?.sizes.filter(item => item.name == 'Vector');

                if (vect.length > 0 && this.images?.sizes?.length >= 2) {
                    this.images?.sizes?.splice(0, this.images?.sizes?.length - 2);
                }
                // else {
                //     this.images.sizes.splice(0, this.images.sizes.length - 1);
                // }
                if (this.editorial.indexOf(this.collection) > -1) {
                    this.usage = true;
                    this.category = 'editorial';
                } else if (this.collection == '179') {
                    this.usage = data.iseditorial;
                    this.category = 'creative';
                }

                if (this.usage) {

                    if (this.type == 'images') {
                        this.usageType = masterData.usage[0]['editorial'];

                    } else {
                        this.usageType = masterData.usage[0]['editorial-videos'];

                    }
                } else {

                    if (this.type == 'images') {
                        this.usageType = masterData.usage[0]['creative'];
                    } else {
                        this.usageType = masterData.usage[0]['creative-videos'];

                    }
                }
                this.usageSelected = this.usageType[0].id;
                // this.imagesPriceExist = false;
                // const imagePrice = this.imagePrices.filter(item => item.id == this.images.filename);
                // if (imagePrice.length > 0) {
                //     this.imagesPriceExist = true;
                // }

                this.cartProduct = Object.assign({
                    id: data.id,
                    filename: data.filename,
                    thumbnail: data.thumbnail,
                    license: data.license,
                    collection: data.collection,
                    size: data?.sizes ? data?.sizes[data.sizes.length - 1]?.name : null,
                    price: 21000,
                    type: this.type == 'images' ? 'Image' : 'Video',
                    caption: data.caption,
                    category: this.category,
                    searchText: this.searchService.search.getValue(),
                    usage: this.usageSelected
                });
                if (this.collection == '219') {
                    this.getCollections();
                    this.getData();
                } else {
                    this.getCollections();

                }

                this.getSubscriptionDetail();
                if (this.images.collection == '179') {
                    this.setRelated(this.images.similar || []);
                    this.topUpSimilar();
                } else {
                    this.getRelatedProducts();
                }

                this.wish = Object.assign({}, this.images);
                // this.wish.id = this.images.filename.replace('ALMY_', '');
                // this.wish.filename = this.images.id + '';
                this.loaded = true;
            });
        }
        
        
    }

    public getVideoById() {
        if(this.currentUser && this.currentUser.user_type == 'BUDGET') {

        }else{
        this.apiService.getVideoById(this.id, this.collection, this.searchService.search.getValue()).subscribe(data => {
            if (data.error && data.error != '') {
                this.exist = false;
            }
            this.images = data;

            // Same reasoning as in getImageById(): the detail accordion only needs
            // `images`, so it must not depend on the enrichment calls below
            // succeeding. See the comment there.
            this.loaded = true;

            this.code = this.images.filename.substr(0, 4);
            this.getCollections();

            this.getVideoSubscriptionDetail();
            this.getRelatedProducts();

            if (this.usage) {
                if (this.type == 'images') {
                    this.usageType = masterData.usage[0]['editorial'];
                } else {
                    this.usageType = masterData.usage[0]['editorial-videos'];

                }
            } else {
                if (this.type == 'images') {
                    this.usageType = masterData.usage[0]['creative'];
                } else {
                    this.usageType = masterData.usage[0]['creative-videos'];

                }
            }

            this.cartProduct = Object.assign({
                id: data.id,
                filename: data.filename,
                thumbnail: data.thumbnail,
                license: data.license,
                collection: data.collection,
                size: data?.sizes ? data?.sizes[data.sizes.length - 1]?.name : null,
                price: data?.sizes ? data?.sizes[data.sizes.length - 1]?.price : null,
                type: 'Video',
                caption: data.caption,
                category: this.category,
                searchText: this.searchService.search.getValue()
            });
            // this.changeSize(this.images.sizes[this.images.sizes.length - 1]);
            this.wish = Object.assign({}, this.images);
            // this.wish.id = this.images.filename.replace('ALMY_', '');
            // this.wish.filename = this.images.id + '';
            this.loaded = true;
        });
        }
    }

    public download(isSubscription: boolean) {
        
        this.disableBtn = true;
        if (this.type == 'images') {
            if(this.currentUser && this.currentUser.user_type == 'BUDGET') {

            }else{
            this.apiService.downloadImage(this.cartProduct, isSubscription).subscribe(data => {
                if (!data || !data[0] || !data[0].download_link) {
                    
                        /*
                         * The backend says WHY when it knows — out of credits, or a
                         * plan that does not cover this collection or size. Those are
                         * things the customer can act on, and "please try again" is
                         * advice to repeat something that will fail identically.
                         * The generic line stays for the cases it cannot explain.
                         */
                        this.toastService.error(
                            (data && data[0] && data[0].message)
                                ? data[0].message
                                : 'Unable to start download. Please try again.'
                        );
                        return;
                    }
                this.disableBtn = false;
                const url = data[0].download_link;
                const a = document.createElement('a');
                a.href = url;
                a.download = this.images.id + '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                if (url != null) {
                    this.images.sizes.filter(item => item.name == this.cartProduct.size)[0].download_link = data[0].download_link;
                    this.images.sizes.filter(item => item.name == this.cartProduct.size)[0].subscription = data[0].subscription;
                    this.btn = 2;
                }
            });
            }
            
        } else {
            if(this.currentUser && this.currentUser.user_type == 'BUDGET') {

            }else{
            this.apiService.downloadVideo(this.cartProduct, isSubscription).subscribe(data => {
                this.disableBtn = false;
                const url = data[0].download_link;
                const a = document.createElement('a');
                a.href = url;
                a.download = this.images.id + '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                if (url != null) {
                    this.images.sizes.filter(item => item.name == this.cartProduct.size)[0].download_link = data[0].download_link;
                    this.images.sizes.filter(item => item.name == this.cartProduct.size)[0].subscription = data[0].subscription;
                    this.btn = 2;
                }
            });
            }
        }
    }

    public reDownloadImage(imageId:any, size:any) {
        if(this.currentUser && this.currentUser.user_type == 'BUDGET') {

        }else{
            this.apiService.reDownloadImageById(imageId, size).subscribe((data:any) => {
                if (data['data']) {

                    const link = document.createElement('a');
                    link.href = data['data'];
                    link.download = ''; // Optional: leave empty or set filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    this.toastService.error('Problem in downloading image, Contact sales to reolve issue');
                }
            });
        }
        
    }

    public changeSize(item:any) {

        if(this.currentUser && this.currentUser.user_type == 'BUDGET')  {
            const size = item;
            if (!size) {
                return;
            }
            this.selectedSize = size;
            this.collectionSize = (this.BUdgetService.Data.categories || [])
                .filter((cat: any) => cat.id == parseInt(this.collection))[0];
            this.cartProduct.size = size.name;
            this.license = this.images?.license;
            if ((this.cartProduct.type || '').toLowerCase() == 'video') {
                if (size.name == 'Web') {
                    this.license = 'Web-240';
                }
                if (size.name == 'SD') {
                    this.license = 'SD';
                }
                if (size.name == 'HD (1080)') {
                    this.license = 'HD';
                }
                if (size.name == 'HD (720)') {
                    this.license = 'HD';
                }
                if (size.name == '4K') {
                    this.license = '4K';
                }
            }
            this.cartProduct.usage = this.license;
            if (size.price != null && size.price > 0) {
                this.cartProduct.price = size.price;
            } else {
                this.cartProduct.price = this.collectionSize?.price?.[this.license] ?? 0;
            }
            this.btn = (size.is_downloaded || this.isAnySizeDownoaded == 1) ? 2 : (size.subscription > 0 ? 1 : 0);

        }else{
            const size = item;
            this.selectedSize = size;

            // const imagePrice = this.imagePrices.filter(item => item.id == this.images.filename);
            if (this.imagePrice && this.imagePrice?.name) {
                const imageP = this.imagePrice?.ip_creative_price?.filter((item1:any) => item1.size == size.name);

                this.cartProduct.price = imageP.length > 0 ? imageP[0].price : 21000;
            } else {
                // this.collectionSize = this.categories.filter(item => item.id == parseInt(this.collection))[0];

                this.cartProduct.size = size.name;
                if (size.price != null && size.price > 0) {
                    this.cartProduct.price = size.price;
                } else {
                    this.selectedSizePrice = this.collectionSize?.ip_creative_price?.filter((item1:any) => item1.size == size.name);
                    this.cartProduct.price = this.selectedSizePrice?.length > 0 ? this.selectedSizePrice[0]?.price : 0;
                    this.media_usage = this.collectionSize?.media_usage ?? '';
                }
            }
            // this.btn = size.is_downloaded ? 2 : ((size.subscription > 0 || size.credit >= this.selectedSizePrice[0][this.usageSelected]) ? 1 : 0);
            this.btn = size.is_downloaded ? 2 : (size.subscription > 0 ? 1 : 0);
        }
    }

    public getVideoSubscriptionDetail() {
        if (this.currentUser) {
            if(this.currentUser && this.currentUser.user_type == 'BUDGET') {

            }else{
                this.apiService.getVideoSubscriptionDetail(this.category,
                this.images.collection, this.images.id, this.images.license).subscribe(data => {
                    this.images?.sizes?.forEach(obj => {
                        const siz = data.filter(item => item.name == obj.name)[0];
                        // obj.subscription = this.images.collection == '211' ?
                        //     ((siz.price_high > 0 && obj.video_downloadable) ? siz.subscription : 0) : siz.subscription;
                        // obj.download_link = siz.download_link;
                        // obj.is_downloaded = siz.is_downloaded;
                        obj.subscription = this.images.collection == '211' ?
                            ((siz.price_high == 0 || (siz.price_high > 0 && obj.price_usd <= siz.price_high)) ? siz.subscription : 0)
                            : siz.subscription;
                        obj.download_link = siz.download_link;
                        obj.is_downloaded = siz.is_downloaded;
                    });

                    this.changeSize(this.images?.sizes[this.images.sizes.length - 1]);
                });
            }
        }
    }

    public getSubscriptionDetail() {
        /*
         * There is nothing to ask for when nobody is signed in.
         *
         * Both branches below report THIS customer's plan balance and whether
         * they already own a download, so the endpoints require a token and the
         * handlers return nothing without one -- their whole body sits inside
         * `if (auth()->user())`. For a guest the call was a guaranteed 401 on
         * every visit to a detail page.
         *
         * changeSize() still runs, because that is what the response callback
         * does once it lands: it picks the default size and fills in the price
         * from the collection's price list, which is public. Skipping it would
         * leave the page with no size selected and no price -- so this keeps the
         * page fully rendered signed out, just without the "you own this" and
         * "your plan covers this" parts, which are meaningless to a guest.
         */
        if (!this.currentUser) {
            this.apiService.hidePreloader();

            // Length-checked rather than `this.images?.sizes[...]`: optional
            // chaining guards `images`, but indexing an undefined `sizes` still
            // throws, and this runs earlier than the callbacks that pattern was
            // written for.
            const sizes = this.images?.sizes;

            if (sizes && sizes.length) {
                this.changeSize(sizes[sizes.length - 1]);
            }

            return;
        }

        if(this.currentUser && this.currentUser.user_type == 'BUDGET') {
            this.apiService.hidePreloader();
            this.BUdgetService.getSubscriptionDetail(this.images.collection, this.images.id, this.images.license, this.type == 'images' ? 'image' : 'video').pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
                this.apiService.hidePreloader();
                this.images?.sizes?.forEach(obj => {
                    const siz = data?.filter((item:any) => item.name == obj.name)[0];
                    obj.subscription = siz?.subscription;
                    obj.credit = siz?.credit;
                    obj.download_link = siz?.download_link;
                    obj.is_downloaded = siz?.is_downloaded;
                });
                this.changeSize(this.images?.sizes[this.images.sizes.length - 1]);
            }, () => {
                this.apiService.hidePreloader();
            });
        }else{
            this.apiService.hidePreloader();
            this.apiService.getSubscriptionDetail(this.category, this.images.collection, this.images.id, this.images.license).subscribe((data:any) => {
                this.apiService.hidePreloader();
                this.images?.sizes?.forEach(obj => {
                    const siz = data?.filter((item:any) => item.name == obj.name)[0];
                    obj.subscription = siz?.subscription;
                    obj.credit = siz?.credit;
                    obj.download_link = siz?.download_link;
                    obj.is_downloaded = siz?.is_downloaded;
                });
                this.changeSize(this.images?.sizes[this.images.sizes.length - 1]);
            }, () => {
                this.apiService.hidePreloader();
            });
        }
            
    }

    public getRelatedProducts() {
        this.relatedProducts = [];

        this.params = [];
        this.params['searchText'] = this.images.caption;
        // this.type = 'image';

        this.params['category'];
        if (this.params['category'] == 'editorial-videos' || this.params['category'] == 'editorial') {
            this.category = 'editorial';
        } else {
            this.category = 'creative';

        }

        this.apiService.hidePreloader();
        this.searchSimilar(this.images.caption).subscribe(rows => {
            this.apiService.hidePreloader();
            this.setRelated(rows);
            this.topUpSimilar();
        }, () => {
            this.apiService.hidePreloader();
        });
    }

    /** Similar images shown: 12 at least where the library has them, 18 at most — two or three rows of six. */
    private static readonly SIMILAR_MIN = 12;
    private static readonly SIMILAR_MAX = 18;

    /** One search for similar rows, through the budget or the main index. */
    private searchSimilar(text: string): Observable<any[]> {
        const search$ = this.currentUser && this.currentUser.user_type == 'BUDGET'
            ? this.BUdgetService.getImages(text, 25, 1, '', true)
            : this.apiService.fetchData({ searchText: text, category: this.params?.['category'] }, 25, this.type, '', true);

        return search$.pipe(
            takeUntil(this.destroy$),
            map((result: any) => (result && result.results) || [])
        );
    }

    /**
     * Keep the list to SIMILAR_MAX, without the image being viewed and without
     * the same image twice — a top-up search overlaps the first one.
     */
    private setRelated(rows: any[]): void {
        const seen = new Set<string>([this.images?.collection + ':' + this.images?.id]);

        this.relatedProducts = (rows || [])
            .filter(row => {
                const key = row.collection + ':' + row.id;
                if (seen.has(key)) { return false; }
                seen.add(key);
                return true;
            })
            .slice(0, MediaDetailComponent.SIMILAR_MAX)
            .map(row => Object.assign(row, { category: this.category }));

        this.previewArr = this.relatedProducts.map((row, i) => ({
            src: row.preview,
            caption: row.caption + '<br/>' + 'Image ' + (i + 1) + ' of ' + this.relatedProducts.length,
            thumb: row.thumbnail
        }));
    }

    /**
     * A full caption is a narrow search and often finds only a handful. Below
     * SIMILAR_MIN, search again on the image's first keyword (or the caption's
     * first word) and add to what is there. If even that falls short, the page
     * shows what exists rather than padding with unrelated images.
     */
    private topUpSimilar(): void {
        if (this.relatedProducts.length >= MediaDetailComponent.SIMILAR_MIN) { return; }

        const caption = (this.images?.caption || '').trim();
        const broader = ((this.images?.tags || []).filter(t => t && String(t).trim())[0]
            || caption.split(/\s+/)[0] || '').trim();

        if (!broader || broader.toLowerCase() === caption.toLowerCase()) { return; }

        const current = this.relatedProducts;
        this.searchSimilar(broader).subscribe(
            rows => this.setRelated(current.concat(rows)),
            () => { /* keep what is already shown */ }
        );
    }

    public compDownload() {
        if(this.currentUser && this.currentUser.user_type == 'BUDGET') {

        }else{
            this.apiService.compDownload(this.cartProduct).subscribe(data => {
            const url = data.download_link;
            window.open(url);
        });
        }
        
    }

    ngOnDestroy(): void {
        document.querySelector('body').classList.remove('sidebar-filter-active');
        this.destroy$.next();
        this.destroy$.complete();
    }


    addCart(event: Event, index = 0) {
        event.preventDefault();
        if (this.currentUser) {
            if (this.currentUser.user_type == 'BUDGET') {
                this.BUdgetService.addToCartListDB(JSON.stringify(this.cartProduct), this.currentUser.customers_id)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((data: any) => {
                        if (data.statusCode === 200) {
                            this.toastService.success('Media added to Cart.');
                        } else {
                            this.toastService.error('Error in adding product to the cart');
                        }
                    });
            } else {
                this.cartService.addToCart(
                    this.cartProduct, 1
                );
            }
        } else {
            this.modalService.showLoginModal();
        }
    }

    addToWishlist(event: Event) {
        event.preventDefault();
        if (this.currentUser) {

            this.modalService.showWishListView(this.wish);
        } else {
            this.modalService.showLoginModal();
        }
    }

    isInWishlist() {

    }


    updateSize($event: MouseEvent, item: Sizes) {
        $event.preventDefault();
        this.changeSize(item);
    }

    @HostListener('window:scroll', ['$event'])
    handleScroll(event: Event) {
        if (document.querySelector('.default-page')) {
            this.scrollHandler();
        }
    }

    scrollHandler() {
        let stickyBar = this.el.nativeElement.querySelector('.sticky-bar');
        if (!stickyBar) {
            return;
        }
        // if (stickyBar.classList.contains('d-none') && this.el.nativeElement.getBoundingClientRect().bottom < 0) {
        if (stickyBar.classList.contains('d-none') && window.pageYOffset > 300) {
            stickyBar.classList.remove('d-none');
            return;
        }
        if (!stickyBar.classList.contains('d-none') && window.pageYOffset < 300) {
            stickyBar.classList.add('d-none');
        }
    }

    onUsageChange($event: any) {
        this.usageSelected = $event.target.value;
        this.cartProduct.usage = this.usageSelected;
        this.changeSize(this.images?.sizes[this.images?.sizes?.length - 1]);

    }

    /* ---------- Buy panel and detail sections (guests and IndiaPicture accounts) ---------- */

    /** The one-off price is shown to guests and to accounts with no plan. */
    get showPrice(): boolean {
        return !this.currentUser
            || (this.currentUser?.plan_id == null && this.currentUser?.user_type == 'INDIAPICTURE');
    }

    /** Which of the three detail sections under the image are expanded. */
    guestOpen = { details: true, licence: true, ai: true };

    toggleGuestSection(key: 'details' | 'licence' | 'ai'): void {
        this.guestOpen[key] = !this.guestOpen[key];
    }

    /** The collections whose every image is AI generated. */
    get isAiCollection(): boolean {
        const name = this.collectionSize?.name;
        return name == 'Creative Images' || name == 'IP - AI' || name == 'IP- AI A' || name == 'Ai Generated';
    }

    /** Same rule as the cart button: an RM image from collection 93 cannot be carted. */
    get canAddToCart(): boolean {
        return this.btn == 0
            && (this.images?.collection != '93' || this.images?.license == 'RF (Royalty Free)');
    }

    /** "864 X 1152" → "864 × 1152". */
    dims(value: any): string {
        return String(value || '').replace(/\s*[xX×]\s*/g, ' × ').trim();
    }

    /** "1024 × 1024 px · 10 × 10 in @ 96 dpi · JPG" for the selected size. */
    sizeSpec(size: any): string {
        if (!size) { return ''; }
        if (size.name == 'Vector') { return 'Scalable to any size'; }

        const parts: string[] = [];

        // The API's dpi sometimes already ends in "dpi" ("300 dpi"); strip it so
        // it is not printed twice.
        const dpi = String(size.dpi || '').replace(/\s*dpi\s*$/i, '').trim();

        if (size.pixels) { parts.push(this.dims(size.pixels) + ' px'); }
        if (size.inches) { parts.push(this.dims(size.inches) + ' in' + (dpi ? ' @ ' + dpi + ' dpi' : '')); }

        const ext = size.ext || (this.images?.filename || '').split('.').pop();
        if (ext && ext !== this.images?.filename) { parts.push(String(ext).toUpperCase()); }

        return parts.join(' · ');
    }

    /** ₹ with Indian digit grouping — "1,50,000", not "150,000". */
    inr(value: any): string {
        return '₹' + (Number(value) || 0).toLocaleString('en-IN');
    }

    /** The image the "Edit with AI" modal is open on; null while it is closed. */
    aiEditSource: AiEditSource | null = null;

    /**
     * Editing spends studio credits, so a signed-out visitor is asked to sign in
     * first. Signed in, the edit modal opens on this image.
     */
    editWithAi(event: Event): void {
        event.preventDefault();
        if (!this.currentUser) {
            this.modalService.showLoginModal();
            return;
        }
        this.aiEditSource = {
            id: this.images?.id,
            filename: this.images?.filename,
            caption: this.images?.caption,
            thumbnail: this.images?.thumbnail,
            size: this.selectedSize?.pixels ? this.dims(this.selectedSize.pixels) : '',
            source: 'image-detail'
        };
    }

    /** The modal's heart: the page's own wishlist dialog. */
    onAiEditWishlist(): void {
        this.modalService.showWishListView(this.wish);
    }

    checkDescription(): boolean {
        const desc = this.images?.desc || '';
        return /(^|\s|-)(ai)(\s|-|$)/i.test(desc);
        // return this.images?.desc.toLowerCase().includes('ai');
    }
}
